"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _GetGoogle2FARecoveryKeyModal = _interopRequireDefault(require("./GetGoogle2FARecoveryKeyModal"));
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _modalActions = require("../../redux/actions/modalActions");
var _snackbarActions = require("../../redux/actions/snackbarActions");
var _userActions = require("../../redux/actions/userActions");
var _reduxForm = require("redux-form");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var form = state.form;
  var recoveryForm = form.google2FARecoveryKeyModal || {
    values: {}
  };
  return {
    recoveryForm: recoveryForm,
    initialValues: {
      recoveryKey: ''
    }
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showSnack: function showSnack(text) {
      return dispatch((0, _snackbarActions.showSnack)(text));
    },
    onCancel: function onCancel() {
      return dispatch((0, _reduxForm.reset)('google2FARecoveryKeyModal'));
    }
  };
};
var containerForm = (0, _reduxForm.reduxForm)({
  destroyOnUnmount: true,
  form: 'google2FARecoveryKeyModal',
  onSubmit: function onSubmit(payload, dispatch) {
    return dispatch((0, _userActions.getGoogle2FARecoveryCode)(payload.code));
  },
  onChange: function onChange(values, dispatch, props) {
    if (values.code && values.code.length === 6) {
      props.submit();
    }
  }
})(_GetGoogle2FARecoveryKeyModal["default"]);
var container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(containerForm);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.GET_GOOGLE_2FA_RECOVERY_CODE
})(container);